/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import moment from "moment";
import ScheduleEntryRow from "./ScheduleEntryRow";

function ScheduleEntryList({
  entries,
  setEntries,
  isEditMode,
  readOnly,
  onEntryRemove,
  siblingHasImmediate
}) {
  const hasImmediateEntry = entries.some(
    (e) => e.notification_send_type === "1" || e.notification_send_type === 1
  );

// When editing one entry on its own, the other rows of the same batch are not
  // loaded, so an Immediate sibling would go unnoticed. Treat it as taken.
  // In the main edit form every row is loaded, so the same rule applies there
  // too — whichever row already holds the Immediate slot blocks the others.
  const isImmediateTakenElsewhere = (entry, index) => {
    if (String(entry.notification_send_type) === "1") return false;
    if (siblingHasImmediate) return true;
    return entries.some(
      (e, i) =>
        i !== index &&
        (e.notification_send_type === "1" || e.notification_send_type === 1)
    );
  };

  const handleUpdate = (index, updatedEntry) => {
    if (readOnly) return;
    const newEntries = [...entries];
    newEntries[index] = updatedEntry;
    setEntries(newEntries);
  };

  const handleRemove = (index) => {
    if (readOnly || entries.length <= 1) return;
    const removed = entries[index];
    if (onEntryRemove && (removed.n_id || removed.p_id)) {
      onEntryRemove(removed.n_id || removed.p_id);
    }
    setEntries(entries.filter((_, i) => i !== index));
  };

  const handleAdd = () => {
    if (readOnly) return;
    setEntries([
      ...entries,
      {
        s_date: moment().format("DD-MM-YYYY"),
        e_date: "",
        notification_send_type: "0",
        n_date_time: "",
        show_on_home: 0,
        _uid: `entry_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
      }
    ]);
  };

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
        Schedule Dates
      </Typography>
      {entries.map((entry, index) => (
        <ScheduleEntryRow
          key={entry._uid || entry.n_id || index}
          entry={entry}
          index={index}
          totalEntries={entries.length}
          hasImmediateEntry={hasImmediateEntry}
          immediateDisabled={isImmediateTakenElsewhere(entry, index)}
          onUpdate={handleUpdate}
          onRemove={handleRemove}
          isEditMode={isEditMode}
          readOnly={readOnly}
        />
      ))}
      {!readOnly && (
        <Button
          startIcon={<Add />}
          variant="outlined"
          onClick={handleAdd}
          sx={{ mt: 1, textTransform: "none" }}
        >
          Add Schedule Date
        </Button>
      )}
    </Box>
  );
}

export default ScheduleEntryList;
